export default "__VITE_ASSET__uTQf34my__"